import React, { useContext, useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../admin.css'
import CountryContext from '../../home/country_context';
import { Button } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { AdminNav } from './admin_nav';
import { AdminSidePane } from './admin-side-pane';
import { AdminMainContent } from '../main-content';
import { RightPane } from '../right-pane';
import { allowedUsersArray } from '../../../util.js/allowedUsersArray';

export const AdminMainWrapper = (props) => {
    const user = useContext(CountryContext)

    return (
        <div className=' admin-body-d9 '>
            <AdminNav />

            {user.allowedAdminUser ?
                <div className=''>
                    <div className='row align-items-start 
                    h-100 justify-content-around'>
                        <div className='col-sm-2 bg-white  px-4 '>
                            <AdminSidePane />
                        </div>
                        <div className='col-sm-10'>
                            {props.children}
                        </div>     
                    </div>
                </div>
                :
                <p className='view_height_100 text-white'>Sorry you cant be here</p>
            }
        </div>
    )
};
